import { z } from 'zod/mini'

/**
 * Keys added by Google Tag Manager to the root of the pushed event.
 * Validation runs on the same object after dispatch, so they may be present.
 * Optional because buffered events (before GTM collects) are not mutated yet.
 */
export const gtmMetadataShape = {
  'gtm.uniqueEventId': z.optional(z.number()),
}
